var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.684 3.05124C8.88913 2.98292 9.11087 2.98292 9.316 3.05124L15 4.94624L19.367 3.49024C19.6676 3.38993 19.9878 3.36251 20.3011 3.41023C20.6145 3.45795 20.912 3.57945 21.1691 3.76472C21.4263 3.94999 21.6357 4.19371 21.7802 4.47581C21.9246 4.75791 22 5.0703 22 5.38724V17.2802C22.0002 17.7 21.8682 18.1093 21.6229 18.4499C21.3775 18.7906 21.0312 19.0454 20.633 19.1782L15.316 20.9502C15.1109 21.0186 14.8891 21.0186 14.684 20.9502L9 19.0542L4.632 20.5102C4.33141 20.6104 4.01135 20.6376 3.69815 20.5898C3.38496 20.542 3.08761 20.4205 2.83059 20.2352C2.57358 20.05 2.36424 19.8063 2.21984 19.5243C2.07543 19.2423 2.00008 18.9301 2 18.6132V6.72024C1.9999 6.30031 2.13198 5.891 2.37752 5.55034C2.62305 5.20967 2.96959 4.95494 3.368 4.82224L8.684 3.05024V3.05124ZM10 17.2802L14 18.6142V6.72024L10 5.38624V17.2802ZM8 5.38724L4 6.72124V18.6132L8 17.2792V5.38724ZM16 6.72124V18.6132L20 17.2792V5.38724L16 6.72124Z",
    fill: "#35d169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCode);
export default __webpack_public_path__ + "static/media/zip-code.c9f4381cd6b6824a5f00c042b64eea8c.svg";
export { ForwardRef as ReactComponent };